import { DefaultService } from "@/api/SolarCloudApi";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { QueryConfig } from "@/lib/react-query";

export function getOrganisationTypesQueryOptions() {
  return queryOptions({
    queryKey: ["organisationTypes"],
    queryFn: getOrganisationTypes,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
}

async function getOrganisationTypes() {
  const response = await DefaultService.organisationType();
  return response;
}

type UseOrganisationTypesOptions = {
  queryConfig?: QueryConfig<typeof getOrganisationTypesQueryOptions>;
};

export function useOrganisationTypes({
  queryConfig,
}: UseOrganisationTypesOptions = {}) {
  return useQuery({
    ...getOrganisationTypesQueryOptions(),
    ...queryConfig,
  });
}
